// 验证码API
import { axios } from '@/utils/axios'

// 获取滑块验证码
export async function fetchCaptcha () {
  try {
    const data = await axios({
      url: '/psg-community-user/api/oauth/captcha/slider/',
      method: 'get',
      params: {
        uuid: new Date().getTime()
      }
    })

    return {
      bg: data.backgroundImage,
      block: data.sliderImage,
      state: data.state
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

// 校验滑块验证码
export async function validateCaptcha (params) {
  try {
    const data = await axios({
      url: `/psg-community-user/api/oauth/captcha/slider/verify?uuid=${new Date().getTime()}`,
      method: 'post',
      data: params
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取手机动态码
export async function fetchMobileCode (params) {
  try {
    const data = await axios({
      url: '/psg-community-user/api/message/sms/sendPhoneCode',
      method: 'post',
      data: params
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取邮箱动态码
export async function fetchEmailCode (params) {
  try {
    const data = await axios({
      url: '/psg-community-user/api/message/sms/sendEmailCode',
      method: 'post',
      data: params
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 手机/邮箱—验证码验证
export async function verifyCode (params) {
  try {
    const data = await axios({
      url: '/psg-community-user/api/message/sms/codeVerify',
      method: 'post',
      data: params
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 用户信息ajax校验
export async function verify (params) {
  try {
    const data = await axios({
      url: '/psg-community-user/api/ajax/verify',
      method: 'post',
      data: params
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}
